import * as React from "react";

const SubDirectoryArrow: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_21421_104957)">
                <path d="M12.6667 10.0001L8.66666 14.0001L7.71999 13.0534L10.1133 10.6667H2.66666V2.66675H3.99999V9.33341H10.1133L7.71999 6.94675L8.66666 6.00008L12.6667 10.0001Z" fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_21421_104957">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(SubDirectoryArrow);